import { SearchUserInterface } from '../../interfaces/search-user.interface';

export class SetSearchUsers {
    public static readonly type = '[MessagingState] Set search users';

    constructor(public users: Array<SearchUserInterface>) { }
}
